module.exports = __webpack_public_path__ + "img/gmdscn-ch-map.ae6bd75a.svg";